import { render, staticRenderFns } from "./assessment-changes.vue?vue&type=template&id=711bd7f8&scoped=true&"
import script from "./assessment-changes.vue?vue&type=script&lang=ts&"
export * from "./assessment-changes.vue?vue&type=script&lang=ts&"
import style0 from "./assessment-changes.vue?vue&type=style&index=0&id=711bd7f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711bd7f8",
  null
  
)

export default component.exports